import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../../../../../../src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { MailListComponent } from '../../../../../../../src/app/features/mailbox/components/mail-list/mail-list.component';
import { HeaderComponent } from '../../../../../shared/header/header.component';
import { SidebarComponent } from '../../../../../shared/sidebar/sidebar.component';
import { SidebarMailboxComponent } from '../../../../../shared/sidebar-mailbox/sidebar-mailbox.component';
import { DomainConfigService } from '../../../../../core/service/domainConfig/domain-config.service';
import { FavIconService } from '../../../../../core/service/fav-icon/fav-icon.service';
import { LocalStorageService } from '../../../../../core/service/localStorage/local-storage.service';

@Component({
  selector: 'app-parent-mail',
  standalone: true,
  imports: [
    SharedModule,
    CommonModule,
    MailListComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarMailboxComponent,
  ],
  templateUrl: './parent-mail.component.html',
  styleUrls: ['./parent-mail.component.scss'], // ✅ fixed here
})
export class ParentMailComponent implements OnInit {
  private domainConfigService = inject(DomainConfigService);
  private faviconService = inject(FavIconService);
  private localStorageService = inject(LocalStorageService);
  private router = inject(Router);
  isActive = false;
  isSwitchUser = false;
  mailData: any;

  ngOnInit(): void {
    const isSwitchUserStr = this.localStorageService.getKey('isSwitchUser');
    this.isSwitchUser = isSwitchUserStr === 'true' || isSwitchUserStr === '"true"';

    const token = this.localStorageService.getKey('access_token');
    if (!token) {
      this.router.navigate(['/login']);
      return;
    }
    this.setupDomainSpecificAssets();
  }

  hamburgerToggleDiv() {
    this.isActive = !this.isActive;
  }

  onBoxSelected(mailData: any) {
    this.mailData = mailData;
  }

  
    /**
   * Setup domain-specific favicon and title
   */
  private setupDomainSpecificAssets(): void {
    const config = this.domainConfigService.getCurrentDomainConfig();
    
    // Set favicon
    if (config.favicon) {
      this.faviconService.setFavicon(config.favicon);
    }

    // Set page title
    if (config.title) {
      this.faviconService.setTitle(config.title);
    }

    // Optional: Add domain-specific class to body for styling
    // this.addDomainClassToBody(config.domain);
  }

   /**
   * Add domain-specific class to body for CSS customization
   */
  private addDomainClassToBody(domain: string): void {
    const cleanDomain = domain.replace(/\./g, '-');
    document.body.classList.add(`domain-${cleanDomain}`);
  }
}
